module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=VN - Vietnam.4a575ff7.svg";